import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async getNowOptions ({ dispatch }) {
    try {
      const { data } = await directus.getItems('now_options')

      dispatch('setNowOptions', data)

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
